import { apiEndpoints } from './api';

export const navigateToLatestThread = async (apiClient, navigate, workspaceId) => {
  try {
    const threads = await apiClient.get(apiEndpoints.threads(workspaceId));
    const normalized = Array.isArray(threads)
      ? threads.map(t => ({ ...t, id: t.id || t._id }))
      : [];

    let targetThread = null;

    if (normalized.length > 0) {
      normalized.sort((a, b) => {
        const aTime = new Date(a.updated_at || a.created_at || 0).getTime();
        const bTime = new Date(b.updated_at || b.created_at || 0).getTime();
        return bTime - aTime;
      });
      targetThread = normalized[0];
    } else {
      const threadData = {
        title: 'New Thread',
        agent_type: 'coding_agent',
        auto_submit_first_message: false,
        message_history: [],
      };
      const created = await apiClient.post(apiEndpoints.threads(workspaceId), threadData);
      targetThread = { ...created, id: created.id || created._id };
    }

    if (targetThread?.id) {
      navigate(`/project/${workspaceId}/thread/${targetThread.id}`);
    } else {
      navigate(`/project/${workspaceId}`);
    }
  } catch (err) {
    console.error('Failed to determine or create latest thread:', err);
    navigate(`/project/${workspaceId}`);
  }
};


